/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useTheme } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';
import { Overview } from '../Overview';

import { Text } from 'components';

export const BasicOverview = ({
  title,
  statementText,
  icon,
}: {
  title: string;
  statementText: string;
  icon: JSX.Element;
}): JSX.Element => {
  const theme: ICustomTheme = useTheme();

  return (
    <Overview
      icon={icon}
      title={title}
      basicOverviewStatement={
        <Text isParagraph={false} color={theme.colors.grey.main} size="body2">
          {statementText}
        </Text>
      }
    />
  );
};
